import React, { useState } from "react";
import { Link } from "react-router-dom";

// import * as Icons from "react-icons/fa";
import "./Navbar.css";
import HLZLogo from '../images/ComponentImg/hlz-logo.png';
import { navItems } from "./NavItems";
import SignUpButton from "./SignUpButton";
import ProdDropdown from "./ProdDropdown";
import ServDropdown from "./ServDropdown";
import SuppDropdown from "./SuppDropdown";

function Navbar() {
  const [proddropdown, setProdDropdown] = useState(false);
  const [servdropdown, setServDropdown] = useState(false);
  const [suppdropdown, setSuppDropdown] = useState(false);

  return (
    <div>
      <nav className='navbar'>
        <div>
          <a className='navbar-logo' href="/">
            <img src={HLZLogo} className='img-fluid w-40' alt="HLZ Logo" />
            <h2> HLZ Technology </h2>
          </a>
        </div>
        {/*
        <Navbar.Brand>
          <img src={HLZLogo} className='img-fluid w-20' alt="" />
          <Link to="/" className='navbar-brand text-success fw-semibold'> HLZ Touch </Link>
        </Navbar.Brand>
        <Link to="/" className='navbar-logo'> NATURE <Icons.FaTree /> </Link>
        */}
        <ul className='nav-items'>
          {navItems.map((item) => {
            if (item.title === "Services") {
              return (
                <li
                  key={item.id}
                  className={item.cName}
                  onMouseEnter={() => setServDropdown(true)}
                  onMouseLeave={() => setServDropdown(false)}
                >
                  <Link to={item.path}>{item.title}</Link>
                  {servdropdown && <ServDropdown />}
                </li>
              );
            }
            if (item.title === "Products") {
              return (
                <li
                  key={item.id}
                  className={item.cName}
                  onMouseEnter={() => setProdDropdown(true)}
                  onMouseLeave={() => setProdDropdown(false)}
                >
                  <Link to={item.path}>{item.title}</Link>
                  {proddropdown && <ProdDropdown />}
                </li>
              );
            }
            if (item.title === "Supports") {
              return (
                <li
                  key={item.id}
                  className={item.cName}
                  onMouseEnter={() => setSuppDropdown(true)}
                  onMouseLeave={() => setSuppDropdown(false)}
                >
                  <Link to={item.path}>{item.title}</Link>
                  {suppdropdown && <SuppDropdown />}
                </li>
              );
            }
            return (
              <li key={item.id} className={item.cName}> <Link to={item.path}>{item.title}</Link> </li>
            );
          })}
        </ul>
        <SignUpButton />
      </nav>
    </div>
  );
}

export default Navbar;
